module.exports = __webpack_public_path__ + "static/media/google-logo.36158af3.png";